import React, { FC } from "react";
import { ListBox, ListBoxItem } from "react-aria-components";
import "./CheckBoxList.scss";

type CheckBoxListProps = {
  lastProps: any;
  items: any[];
  selectedItems: any[];
  setSelectedItem: (selectedItems: any[]) => void;
  selectionMode: "single" | "multiple";
  startIndex?: number;
};

const CheckBoxList: FC<CheckBoxListProps> = ({ lastProps, items, selectedItems, setSelectedItem, selectionMode, startIndex = 0 }) => {

  return (
    <div className="CheckBoxList">
      <ListBox
        aria-label={lastProps.selectionLabel}
        items={items}
        selectionMode={selectionMode}
        layout="grid"
        className="d-flex w-100 align-items-center justify-content-center custom-period-buttons-container"
        selectedKeys={selectedItems}
        onSelectionChange={keys => setSelectedItem(Array.from(keys))}
      >
        {items.map((period, index) => {
          const key = (startIndex + index) % lastProps.periods.length;
          return (
            <ListBoxItem
              aria-label={period.description ?? period}
              textValue={(period.description ?? period).toString()}
              key={key}
              id={key}
              className={`custom-period-selector-button ${selectedItems.includes(key) ? "group-selected: active" : ""
                }`}
            >
              {lastProps.renderButtonContent(period)}
            </ListBoxItem>
          );
        })}
      </ListBox>
    </div>
  );
};

export default CheckBoxList;